module.exports = __webpack_public_path__ + "media/img/logos/2024/horizontal/tag_des_wissens-c4f5bad16a88673941c28d99ea1650af.svg";